<template>
    <div>

        <Loadingcircle v-if="loading"/>

   
    <div v-else>
        <div v-if="!showing">
            <section class="mla-list-sec mock-home-sec">
                <div class="container">
                    <div class="mla-list-layout mock-home-layout">
                        <div class="mlalist-left-section">
                            <div class="mlalist-left-full">
                                <SidebarSearchBox
                                    v-model="searchQuery"
                                    theme="mocks"
                                    @search="openSearch"
                                />
                                <div class="questions-notes-mocks">
                                    <div
                                        class="mla-question-box"
                                        :class="{ 'is-section-locked': isSectionLocked('questions') }"
                                        :style="{ cursor: isSectionLocked('questions') ? 'not-allowed' : 'pointer' }"
                                        :title="isSectionLocked('questions') ? 'Locked Section' : ''"
                                        @click="openExitAlert('Question')"
                                    >
                                        <SectionLockBadge v-if="isSectionLocked('questions')" />
                                        <div class="section-card-body">
                                            <h4><img src="/images/questionmark.png" alt="img"> Questions</h4>
                                            <ProgressBar
                                                v-if="!isSectionLocked('questions')"
                                                :progress="questionsProgressPercent"
                                                label="Progress"
                                                :detail="questionsProgressDetail"
                                            />
                                        </div>
                                        <div class="cardbottom-shadow">
                                            <img src="/images/cardshadow.png" alt="">
                                        </div>
                                    </div>
                                    <div
                                        class="mla-question-box mla-note-box"
                                        :class="{ 'is-section-locked': isSectionLocked('notes') }"
                                        :style="{ cursor: isSectionLocked('notes') ? 'not-allowed' : 'pointer' }"
                                        :title="isSectionLocked('notes') ? 'Locked Section' : ''"
                                        @click="openExitAlert('Notes')"
                                    >
                                        <SectionLockBadge v-if="isSectionLocked('notes')" />
                                        <div class="section-card-body">
                                            <h4><img src="/images/file.png" alt="img"> Notes</h4>
                                            <ProgressBar
                                                v-if="!isSectionLocked('notes')"
                                                :progress="notesProgressPercent"
                                                label="Progress"
                                                :detail="`${notesRead}/${notesTotal}`"
                                            />
                                        </div>
                                        <div class="cardbottom-shadow">
                                            <img src="/images/cardshadow.png" alt="">
                                        </div>
                                    </div>
                                    <div
                                        class="mla-question-box mla-mock-box"
                                        :class="{ 'is-section-locked': isSectionLocked('mocks') }"
                                        :style="isSectionLocked('mocks') ? { cursor: 'not-allowed' } : null"
                                        :title="isSectionLocked('mocks') ? 'Locked Section' : ''"
                                        @click="onMocksCardClick"
                                    >
                                        <SectionLockBadge v-if="isSectionLocked('mocks')" />
                                        <div class="section-card-body">
                                            <h4><img src="/images/brain.png" alt="img"> Mocks</h4>
                                            <div
                                                v-if="!isSectionLocked('mocks')"
                                                class="mocks-summary-toggle"
                                                title="Click to switch between Score and Progress"
                                                @click.stop="onMocksSummaryClick"
                                            >
                                                <ProgressBar
                                                    :progress="mocksSummaryDisplayPercent"
                                                    :label="mocksSummaryShowProgress ? 'Progress' : 'Score'"
                                                    :mode="mocksSummaryShowProgress ? 'progress' : 'score'"
                                                    :detail="mocksSummaryDetail"
                                                />
                                            </div>
                                        </div>
                                        <div class="cardbottom-shadow">
                                            <img src="/images/cardshadow.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mlalist-right-section mock-home-right">
                            <div class="mock-container">
                                <div
                                    class="mock-card"
                                    data-aos="fade-up"
                                    data-aos-delay="0"
                                    data-aos-duration="800"
                                    v-for="(items, index) in title"
                                    :key="index"
                                >
                                    <div class="mock-card-wrapper">
                                        <div class="mock-image" @click="content(items, index)">
                                            <img :src="`/images/mock${index + 1}.png`" alt="">
                                        </div>
                                        <div class="mock-card-footer" @click="content(items, index)">
                                            <div
                                                class="mock-score-bar-wrap"
                                                v-if="items.score && items.score.length > 0 && !items.exit"
                                            >
                                                <div class="mock-score-bar">
                                                    <div
                                                        class="mock-score-fill"
                                                        :style="{ width: getMockScore(items) + '%' }"
                                                    ></div>
                                                </div>
                                                <span class="mock-score-label">{{ getMockScore(items) }}%</span>
                                            </div>
                                            <div class="mock-score-bar-wrap" v-else-if="items.exit">
                                                <div class="mock-score-bar mock-score-bar--paused">
                                                    <div
                                                        class="mock-score-fill mock-score-fill--paused"
                                                        style="width:40%"
                                                    ></div>
                                                </div>
                                                <img
                                                    class="pause-icon-sm"
                                                    src="/images/pauseyellowicon.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="mock-not-attempted" v-else>Not attempted yet</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div v-if="showExitPopup" class="overlay">
                <div class="popup">
                    <p>Are you sure you want to exit mock screen?</p>
                    <div class="actions">
                        <button class="yes" @click="confirmExit">Yes</button>
                        <button class="no" @click="showExitPopup = false">No</button>
                    </div>
                </div>
            </div>

            <SectionSubscribeModal
              :open="showSubscribePopup"
              :message="subscribeMessage"
              @close="showSubscribePopup = false"
            />
        </div>

        
      

       

        <MockSelection v-else :indexing="indexing" />

    </div>

  
</div>
</template>


<script>
// import AttemptProgressButton from '@/components/AttemptProgressButton.vue';
import MockSelection from './MockSelection.vue';
import Vue from 'vue';
import { get } from './lib/api';
import {
    mocksAggregateScorePercent as calcMocksScorePercent,
    mocksAggregateProgressPercent as calcMocksProgressPercent,
    mocksAggregateTotals,
} from './lib/mocksAggregate';
import { hydrateNoteUserState, notesProgressStats } from './lib/notesUserPrefs';
import Loadingcircle from '@/components/Loadingcircle.vue';
import SidebarSearchBox from '@/components/SidebarSearchBox.vue';
import ProgressBar from '@/components/HomepageProgress.vue';
import SectionLockBadge from '@/components/SectionLockBadge.vue';
import SectionSubscribeModal from '@/components/SectionSubscribeModal.vue';
import { emptySectionLocks, fetchSectionLocks, subscribeSectionMessage } from './lib/sectionLocks';

export default {
    name: "MockSection",
    components: {
        MockSelection,
        Loadingcircle,
        SidebarSearchBox,
        ProgressBar,
        SectionLockBadge,
        SectionSubscribeModal,
    },

    data() {
        return {
            exitpage:'',
            showExitPopup:false,
            showSubscribePopup: false,
            subscribeMessage: '',
            loading:true,
            showing: false,
            indexing: 0,
            showscore: true,
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            password_confirm: "",
            isLoading: false,
            title: [],
            showscore1: true,
            showscore2: false,
            showscore3: false,
            selectedItem: null,
            animationbutton: false,
            loadershow: true,
            percentage:0,
            clinicalAreas: [],
            professionalKnowledge: [],
            notesClinicalAreas: [],
            notesProfessionalKnowledge: [],
            notesReadRev: 0,
            searchQuery: '',
            /** false = Score (correct / all mock questions), true = Progress (attempted / all) */
            mocksSummaryShowProgress: true,
            sectionLocks: emptySectionLocks(),
        }
    },


    created() {

        console.log(window.innerWidth , window.innerHeight);

            console.log('toekn' , localStorage.getItem('token'))

        fetchSectionLocks().then((locks) => {
            this.sectionLocks = locks;
        });

        get('/getmocks')
            .then((res) => {

                this.setData(res)

            })

        get('/getsubjectclient')
            .then((res) => {
                this.clinicalAreas = res.data.clinical || []
                this.professionalKnowledge = res.data.professional || []
            })

        hydrateNoteUserState();

        get('/notesclient')
            .then((res) => {
                if (res.data.chaptersClinical) {
                    this.notesClinicalAreas = this.transformNotesChapters(res.data.chaptersClinical);
                }
                if (res.data.chaptersProfessioanl) {
                    this.notesProfessionalKnowledge = this.transformNotesChapters(res.data.chaptersProfessioanl);
                }
            })
            .catch((err) => {
                console.error('Error fetching notes data:', err);
            });




    },

    mounted() {
        this._notesPrefsStorage = (ev) => {
            if (ev && ev.key && String(ev.key).indexOf('notesUserPrefs_') === 0) {
                this.notesReadRev += 1;
            }
        };
        window.addEventListener('storage', this._notesPrefsStorage);
    },

    activated() {
        this.notesReadRev += 1;
    },

    beforeDestroy() {
        if (this._notesPrefsStorage) {
            window.removeEventListener('storage', this._notesPrefsStorage);
        }
    },

    computed: {
        questionsTotals() {
            const all = [...this.clinicalAreas, ...this.professionalKnowledge];
            const total = all.reduce((s, i) => s + (parseInt(i.questions_count, 10) || 0), 0);
            const attempted = all.reduce((s, i) => s + (parseInt(i.attempted_count, 10) || 0), 0);
            return { total, attempted };
        },

        questionsProgressPercent() {
            const { total, attempted } = this.questionsTotals;
            if (!total) return 0;
            return Math.round((attempted / total) * 100);
        },

        questionsProgressDetail() {
            return `${this.questionsTotals.attempted}/${this.questionsTotals.total}`;
        },

        notesSidebarProgress() {
            void this.notesReadRev;
            void this.notesClinicalAreas.length;
            void this.notesProfessionalKnowledge.length;
            return notesProgressStats(this.$store, [
                ...this.notesClinicalAreas,
                ...this.notesProfessionalKnowledge,
            ]);
        },

        notesProgressPercent() {
            return this.notesSidebarProgress.percent;
        },

        notesRead() {
            return this.notesSidebarProgress.read;
        },

        notesTotal() {
            return this.notesSidebarProgress.total;
        },

        mocksAggregateScorePercent() {
            return calcMocksScorePercent(this.title);
        },

        mocksAggregateProgressPercent() {
            return calcMocksProgressPercent(this.title);
        },

        mocksSummaryDisplayPercent() {
            return this.mocksSummaryShowProgress
                ? this.mocksAggregateProgressPercent
                : this.mocksAggregateScorePercent;
        },

        mocksSummaryDetail() {
            const t = mocksAggregateTotals(this.title);
            if (this.mocksSummaryShowProgress) {
                return `${t.totalAttempted}/${t.totalQuestions}`;
            }
            return `${t.totalCorrect}/${t.totalQuestions}`;
        },
    },

    methods: {
        toggleMocksSummaryMode() {
            this.mocksSummaryShowProgress = !this.mocksSummaryShowProgress;
        },
        onMocksSummaryClick() {
            if (this.isSectionLocked('mocks')) {
                this.openSubscribePopup('mocks');
                return;
            }
            this.toggleMocksSummaryMode();
        },
        onMocksCardClick() {
            if (this.isSectionLocked('mocks')) {
                this.openSubscribePopup('mocks');
            }
        },
        isSectionLocked(key) {
            return !!(this.sectionLocks && this.sectionLocks[key]);
        },
        openSubscribePopup(sectionKey) {
            this.subscribeMessage = subscribeSectionMessage(sectionKey);
            this.showSubscribePopup = true;
        },

        openSearch(payload) {
            const q = (payload && payload.q) || String(this.searchQuery || '').trim();
            if (!q) return;
            const categories = (payload && payload.categories) || [];
            this.$router.push({
                path: '/search',
                query: {
                    from: this.$route.fullPath,
                    q,
                    source: 'mocks',
                    ...(categories.length ? { categories: categories.join(',') } : {}),
                },
            });
        },

        transformNotesChapters(chapters) {
            if (!chapters || !Array.isArray(chapters)) return [];

            return chapters.map((chapter) => {
                const transformedChapter = {
                    id: chapter.id || null,
                    title: chapter.title || '',
                    index_number: chapter.index_number || null,
                };

                if (chapter.notes && Array.isArray(chapter.notes) && chapter.notes.length > 0) {
                    transformedChapter.children = chapter.notes.map((note) => {
                        const transformedNote = {
                            id: note.id || null,
                            title: note.title || '',
                            index_number: note.index_number || null,
                        };

                        if (note.sub_notes && Array.isArray(note.sub_notes) && note.sub_notes.length > 0) {
                            transformedNote.children = note.sub_notes.map((subNote) => ({
                                id: subNote.id || null,
                                title: subNote.title || '',
                                index_number: subNote.index_number || null,
                            }));
                        }

                        return transformedNote;
                    });
                }

                return transformedChapter;
            });
        },

        openExitAlert(e){
      if ((e === 'Question' || e === 'Questions') && this.isSectionLocked('questions')) {
        this.openSubscribePopup('questions');
        return;
      }
      if (e === 'Notes' && this.isSectionLocked('notes')) {
        this.openSubscribePopup('notes');
        return;
      }
      if (e === 'Mocks' && this.isSectionLocked('mocks')) {
        this.openSubscribePopup('mocks');
        return;
      }
      if (e === 'Question' || e === 'Questions') {
        this.$router.push('/mlalistselection');
        return;
      }
      if (e === 'Notes') {
        this.$router.push('/noteslistselection');
        return;
      }
      this.$router.push('/mocksection');
    },
    confirmExit() {
      this.showExitPopup = false;
      if (this.exitpage == 'Question') {
        if (this.isSectionLocked('questions')) return;
        this.$router.push('/mlalistselection');
      } else if (this.exitpage == 'Notes') {
        if (this.isSectionLocked('notes')) return;
        this.$router.push('/noteslistselection');
      } else {
        if (this.isSectionLocked('mocks')) return;
        this.$router.push('/mocksection');
      }
    },

        showselections(e) {
            this.indexing = e
            this.showing = true
        },

        setData(res) {


            Vue.set(this.$data, 'title', res.data.data)
            Vue.set(this.$data, 'percentage', res.data.percentage)


            console.log('here', res.data.data)
            this.loadershow = false
            this.loading = false

            

           

        },


        SetScoreShow() {
            this.showscore = !this.showscore;
        },

        SetScoreShows(e) {

            if (e == 1) {
                this.showscore2 = false;
                this.showscore3 = false;

                this.showscore1 = !this.showscore1;

            }
            if (e == 2) {
                this.showscore1 = false;
                this.showscore3 = false;
                this.showscore2 = !this.showscore2;

            }

            if (e == 3) {
                this.showscore1 = false;
                this.showscore2 = false;
                this.showscore3 = !this.showscore3;

            }
        },


        deletescore(id) {

            get("/deletescore?id=" + id).then((res) => {
                if (res.data.deleted) {

                    // this.$toast.success("Score Successfully Reset");
                    console.log("deleted")
                    get('/getmocks')
                        .then((res) => {

                            this.setData(res)

                        })
                }

            });

        },
        getButtonColor(items) {
            return items.score && items.score.length > 0 ? '#63B045' : 'red';
        },

        getMockScore(item) {
            if (!item.score || !item.quest || item.quest.length === 0) return 0;
            const correctCount = item.score.filter(s => s.correct == 1).length;
            return Math.round((correctCount * 100) / item.quest.length);
        },

       


        content(e , index) {
            console.log('yes', e)
            this.selectedItem = e;

            localStorage.setItem('mockindex', index + 1);

            setTimeout(() => {

                if (e.score && e.score.length > 0 && !e.exit) {
                    console.log('heading', e)
                    // this.$toast.warning('Already Attempted')
                    localStorage.setItem('mockObject', JSON.stringify(e));
                    localStorage.setItem('question', 'normal');
                    localStorage.setItem("remainingsec", null);


                    this.$router.push({ path: `/reviewscroll/${e.id}` });

                }
                else if (e.exit) {

                    // this.$toast.warning('Already Paused')


                    localStorage.setItem('question', 'exitmock');
                    this.$router.push({ path: `/mocksquestion/${e.id}` });
                }

                else {


                    localStorage.setItem('mockObject', JSON.stringify(e));
                    localStorage.setItem('question', 'normal');
                    localStorage.setItem("remainingsec", null);
                    // this.$router.push('/contentmap');
                    // this.$router.push({ path: `/startmockquestion/${e.id}` });
                    this.indexing = e
                    this.showing = true
                }
            }, 500);

        },
       
    }
};
</script>



<style scoped>
/* Mocks home layout — scoped so other pages stay unchanged */
.mock-home-sec {
    padding: 30px 0 s0px;
}

.mock-home-layout {
    display: flex;
    gap: 54px;
    align-items: stretch;
    min-height: calc(100vh - 180px);
}

.mock-home-layout .mlalist-left-section {
    flex: 0 0 20%;
    display: flex;
    flex-direction: column;
}

.mock-home-layout .mlalist-left-full {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 auto;
    min-height: 100%;
}

.mock-home-layout .mlalist-right-section {
    flex: 0 0 75.5%;
    background: transparent;
    display: flex;
    align-items: center;
    padding-top: 50px;
}

/* Same progress cards as Questions/Notes list sidebars */
.mock-home-layout .mla-question-box {
    background: #1A90FF;
    border: 1px solid #0276BA;
    margin: 30px 0 0;
    padding: 0;
    border-radius: 16px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    overflow: hidden;
    border: none;
}

.mock-home-layout .mla-question-box .section-card-body {
    flex: 1;
    min-width: 0;
    padding: 5px 6px 2px;
    box-sizing: border-box;
}

.mock-home-layout .mla-question-box .cardbottom-shadow img {
    left: 50%;
    transform: translate(-50%);
    bottom: -27px;
    width: 350px;
}

.mock-home-layout .mla-question-box h4 {
    font-size: 22px;
    color: #fff;
    text-transform: uppercase;
    padding: 0 0 6px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
}

.mock-home-layout .mla-question-box h4 img {
      width: 27px;
    height: 27px;
    object-fit: contain;
}

.mock-home-layout .mla-note-box {
    background-color: #F59C00;
    border-color: #F59C00;
    border: none;
}

.mock-home-layout .mla-mock-box {
    background-color: #ED1C24;
    border-color: #ED1C24;
    border: none;
}

/* Locked sidebar card: same height feel, title centered, no progress */
.mock-home-layout .mla-question-box.is-section-locked {
    min-height: 70px;
}

.mock-home-layout .mla-question-box.is-section-locked .section-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 70px;
}

.mock-home-layout .mla-question-box.is-section-locked h4 {
    padding: 0;
}

.mock-home-layout .mocks-summary-toggle {
    cursor: pointer;
    user-select: none;
}

.mock-home-layout .mock-container {
    width: 100%;
    max-width: 820px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px 24px;
}

.mock-home-layout .mock-card {
    min-width: 0;
    max-width: 185px;
    justify-self: center;
    width: 100%;
}

.mock-home-layout .mock-image img {
    padding: 10px !important;
}

.mock-home-layout .mock-card-wrapper {
    padding: 4px;
}

.mock-home-layout .mock-card-footer {
    padding: 8px 2px 2px;
}

.mock-home-layout .mock-score-bar {
    height: 18px;
}

.mock-home-layout .mock-score-label {
    font-size: 11px;
}

@media (max-width: 1200px) {
    .mock-home-layout .mock-container {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 28px;
    }
}

@media (max-width: 767px) {
    .mock-home-layout {
        flex-direction: column;
        gap: 36px;
    }

    .mock-home-layout .mlalist-left-section,
    .mock-home-layout .mlalist-right-section {
        flex: 1 1 100% !important;
        max-width: 100%;
    }

    .mock-home-layout .mock-container {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }
}

.overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
  
  .popup {
    background: #fff;
    padding: 20px 25px;
    border-radius: 8px;
    width: 320px;
    text-align: center;
  }
  
  .actions {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  
  button {
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .yes {
    background: #e53935;
    color: white;
  }
  
  .no {
    background: #ccc;
  }
  
  .exit-text {
    color: #1976d2;
    cursor: pointer;
    text-decoration: underline;
  }
  

.progress-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

img.progressicon {
    border: none;
    padding: 0;
}





.lock-hover-text {
    position: absolute;
    width: 95px;
    left: 4%;
    top: -2px;
    font-size: 10px;
    background-color: #9DED6C;
    padding: 3px 3px;
    border-radius: 6px;
    color: #000000;
    visibility: hidden;
    opacity: 0;
}

.lock-hover-text::before {
    position: absolute;
    content: "";
    background: #9DED6C;
    width: 10px;
    height: 10px;
    bottom: -9px;
    clip-path: polygon(0 0, 0% 100%, 100% 0);
    right: 55px;
}
img {
    cursor: pointer;


}

.progress-container {
    position: relative;
    width: 100%;
}

.progress-bar {
    height: 10px;
    background: #D1D3D4;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    border: 1px solid white;
   
}

.progress-fill {
    height: 100%;
    background: #9DED6C;
    border-radius: 14px;
    transition: width 0.3s ease-in-out;
    position: relative;
    z-index: 1;
    border-right: 1px solid #6d6e716e;
}

.progress-text {
 
    color: white;
    font-size: 17px;
   
    z-index: 2;
    user-select: none;
    pointer-events: none;
    font-family: HelveticaBoldcont;
}


.question-score {
    display: flex;
    gap: 8px;
    position: relative;
    align-items: center;
}

.mocks-summary-toggle,
.questions-summary-toggle {
    cursor: pointer;
    user-select: none;
}


[data-aos] {
    visibility: hidden;
}

[data-aos].aos-animate {
    visibility: visible;
}


.mock-image {
    position: relative;
    line-height: 0;
}

.mock-image img {
    width: 100%;
    display: block;
   
        padding: 10px !important;
}

/* Red-border wrapper that contains image + status bar */
.mock-card-wrapper {
    /* border: 1.5px solid #ED1C24; */
    
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
        padding: 5px;
}

.mock-card-wrapper:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(237, 28, 36, 0.2);
}

/* Footer sits below the image, inside the red border */
.mock-card-footer {
       padding: 10px 0px 0px;
    background: #fff;
}

.mock-score-bar-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
}

.mock-score-bar {
    flex: 1;
    height: 20px;
    background: #D1D3D4;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid #aaa;
}

.mock-score-fill {
    height: 100%;
    background: #9DED6C;
    border-radius: 20px;
    transition: width 0.4s ease;
}

.mock-score-bar--paused {
    background: rgba(251, 173, 31, 0.15);
    border-color: #FBAD1F;
}

.mock-score-fill--paused {
    background: #FBAD1F;
}

.mock-score-label {
    font-size: 11px;
    font-weight: 700;
    color: #231F20;
    min-width: 26px;
    text-align: right;
    position: absolute;
    left: 30%;
}

.pause-icon-sm {
    width: 16px;
    height: 16px;
    border: none !important;
    padding: 0 !important;
    cursor: default;
}

.mock-not-attempted {
    background: #D1D3D4;
    color: #58595B;
    font-size: 9px;
    font-weight: 600;
    text-align: center;
    border-radius: 20px;
    padding: 4px 8px;
    white-space: nowrap;
    border: 1px solid #aaa;
}


</style>